export const FormatUnderlineIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="22" height="24" viewBox="0 0 20 20" fill="none">
    <path
      d="M5.00004 3.33331V8.33331C5.00004 9.6594 5.52682 10.9312 6.46451
       11.8688C7.40219 12.8065 8.67396 13.3333 10 13.3333C11.3261 13.3333
        12.5979 12.8065 13.5356 11.8688C14.4733 10.9312 15 9.6594 15 8.33331V3.33331M3.33337 16.6666H16.6667"
      stroke="#8A8A8E"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
